import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Risky Business OBX · Event Entertainment Services</p>
        <h1>Unforgettable Events in the Outer Banks</h1>
        <p className="lede">
          Elevate your gatherings with our premier entertainment services tailored for the Outer Banks region. 
          From lively music to engaging activities, we bring your vision to life.
        </p>
        <div className="cta-row">
          <a href="#services" target="_self">
            Explore Our Services
          </a>
          <a href="#contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Tailored Entertainment</h2>
          <p>
            Whether it's a wedding, corporate event, or private party, we customize our entertainment options to fit your needs and create lasting memories.
          </p>
        </article>
        <article>
          <h2>Local Expertise</h2>
          <p>
            With deep roots in the Outer Banks, we understand the unique vibe of the area and can recommend the best options to enhance your event.
          </p>
        </article>
        <article>
          <h2>Seamless Planning</h2>
          <p>
            Our dedicated team handles all the details, ensuring a smooth experience from start to finish, so you can focus on enjoying your event.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;